import { render, staticRenderFns } from "./books-small.vue?vue&type=template&id=403aec31&scoped=true&"
import script from "./books-small.vue?vue&type=script&lang=js&"
export * from "./books-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403aec31",
  null
  
)

export default component.exports